<template><span style="display: none"></span></template>

<script>
const signalR = require("@microsoft/signalr");

export default {
  name: "MiniNotificacionSocial",
  data() {
    return {
      snack: false,
      snackColor: "primary",
      snackTime: 10000,
      socialHubConnection: null,
      numeroTelefono: null,
      audio: new Audio(require("../../assets/new-notification-022-370046.mp3")),
      reproduciendoAudio: false,
    };
  },
  created() {
    this.notificacionSocial();
  },
  beforeDestroy() {
    if (this.socialHubConnection) {
      this.socialHubConnection.off(
        "ReceiveNotification",
        this.onReceiveNotification
      );
      this.socialHubConnection.stop();
      this.socialHubConnection = null;
    }

    if (this.audio) {
      this.audio.pause();
      this.audio.currentTime = 0;
      this.audio.onended = null;
    }
  },
  methods: {
    notificacionSocial() {
      if (!this.socialHubConnection) {
        this.socialHubConnection = new signalR.HubConnectionBuilder()
          .withAutomaticReconnect()
          .withUrl(process.env.VUE_APP_AXIOS + "/NotificacionSocial", {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets,
          })
          .build();

        this.socialHubConnection.onreconnected(() => {
          console.log("SignalR reconectado");
        });

        this.socialHubConnection
          .start()
          .then(() => console.log("Conectado a Notificaciones WhatsApp"))
          .catch((err) => console.error("Error SignalR", err));
      }

      this.socialHubConnection.off(
        "ReceiveNotification",
        this.onReceiveNotification
      );
      this.socialHubConnection.on(
        "ReceiveNotification",
        this.onReceiveNotification
      );
    },
    onReceiveNotification(model) {
      this.numeroTelefono = model.numeroTelefono;
      this.$store.commit("UPSERT_CHAT", model);
      this.mostrarNotificacion(model.numeroTelefono);
    },
    openChat(numero) {
      // const url = `http://localhost:8080/ContactosWa/${numero}`;

      // window.open(url, "_blank");
      window.open(
        `${process.env.VUE_APP_AXIOS}/ContactosWa/${numero}`,
        "_blank"
      );
    },
    mostrarNotificacion(numero) {
      this.notificacionAuditiva();
      // this.notificacionVisual(numero);
    },
    onAudioEnded() {
      this.reproduciendoAudio = false;
    },
    notificacionAuditiva() {
      if (this.reproduciendoAudio) return;

      this.audio.currentTime = 0;

      this.reproduciendoAudio = true;
      this.audio.play().catch(() => {
        this.reproduciendoAudio = false;
      });

      this.audio.onended = this.onAudioEnded();
    },
    notificacionVisual(numero) {
      let incluirNumero = numero ? `Cliente ${numero}` : "";
      let textoBase = "Nuevo Mensaje por WhatsApp de";
      const textoNotificacion = `${textoBase} ${incluirNumero}`;
      this.$toast.info(textoNotificacion, {
        position: "top-right",
        closeOnClick: true,
        draggable: false,
        timeout: 10000,
        pauseOnHover: false,
        closeButton: false,
        onClick: () => {
          this.openChat(numero);
        },
      });
    },
  },
  computed: {},
};
</script>